<div
    *transloco="let tButtons; read: 'buttons'"
    class="flex sm:flex-row xsm:flex-col xsm:items-start sm:items-center gap-2 w-full xsm:body-1"
>
    <app-automation-buttons
        class="xsm:w-full sm:w-auto"
        [displayTooltip]="displayTooltip"
        [dark]="dark"
        [selectedRecords]="selectedRecords"
    ></app-automation-buttons>
    <!-- will be investigated further by designer, could be changed after investigation -->
    <app-tb-tooltip-component
        *appEnv="'prod'; visible: false"
        [tooltip]="tButtons('set_assignee')"
        [tooltipDisabled]="!displayTooltip"
        class="xsm:w-full sm:w-auto"
    >
        <app-tb-button
            [dark]="dark"
            icon="people_outline"
            appearance="text"
            class="xsm:rounded text-left xsm:bg-neutral2 sm:bg-transparent xsm:w-full xsm:body-1 sm:body-2"
        >
            <span class="xsm:block sm:hidden lg:inline-flex body-2 xsm:body-1 sm:body-2 text-left">
                {{ tButtons('set_assignee') }}
            </span>
        </app-tb-button>
    </app-tb-tooltip-component>
    <app-tb-tooltip-component
        class="xsm:w-full sm:w-auto"
        [tooltip]="tButtons('set_status')"
        [tooltipDisabled]="!displayTooltip"
        *appEnv="'prod'; visible: false"
    >
        <app-tb-button
            [dark]="dark"
            icon="task_alt"
            appearance="text"
            color="xsm:text sm:white"
            class="xsm:rounded text-left xsm:bg-neutral2 sm:bg-transparent xsm:w-full xsm:body-1 sm:body-2"
        >
            <span class="xsm:block sm:hidden lg:inline-flex xsm:body-1 sm:body-2 text-left">
                {{ tButtons('set_status') }}
            </span>
        </app-tb-button>
    </app-tb-tooltip-component>
    <app-tb-tooltip-component
        [tooltip]="tButtons('favorite')"
        [tooltipDisabled]="!displayTooltip"
        class="xsm:w-full sm:w-auto"
    >
        <app-tb-button
            (click)="setFavorite()"
            [dark]="dark"
            color="xsm:text sm:white"
            icon="star_outline"
            appearance="text"
            class="xsm:rounded text-left xsm:bg-neutral2 sm:bg-transparent xsm:w-full xsm:body-1 sm:body-2 xsm:text-text sm:text-white"
        >
            <span
                class="xsm:block sm:hidden lg:inline-flex xsm:body-1 sm:body-2 text-left xsm:ms-2 sm:ms-0"
            >
                {{ tButtons('favorite') }}
            </span>
        </app-tb-button>
    </app-tb-tooltip-component>
    <app-tb-tooltip-component
        [tooltip]="tButtons('share')"
        [tooltipDisabled]="!displayTooltip"
        *appEnv="'prod'; visible: false"
        class="xsm:w-full sm:w-auto"
    >
        <app-tb-button
            [dark]="dark"
            icon="share"
            color="xsm:text sm:white"
            appearance="text"
            class="xsm:rounded xsm:bg-neutral2 sm:bg-transparent xsm:w-full xsm:body-1 sm:body-2 xsm:text-text sm:text-white"
        >
            <span class="xsm:block sm:hidden lg:inline-flex xsm:body-1 sm:body-2 xsm:ms-2 sm:ms-0">
                {{ tButtons('share') }}
            </span>
        </app-tb-button>
    </app-tb-tooltip-component>
    <app-tb-tooltip-component
        [tooltip]="tButtons('duplicate')"
        [tooltipDisabled]="!displayTooltip"
        *appEnv="'prod'; visible: false"
        class="xsm:w-full sm:w-auto"
    >
        <app-tb-button
            [dark]="dark"
            icon="custom_copy"
            color="xsm:text sm:white"
            appearance="text"
            class="xsm:rounded xsm:bg-neutral2 sm:bg-transparent xsm:w-full xsm:body-1 sm:body-2 xsm:text-text sm:text-white"
        >
            <span class="xsm:block sm:hidden lg:inline-flex xsm:body-1 sm:body-2 xsm:ms-2 sm:ms-0">
                {{ tButtons('duplicate') }}
            </span>
        </app-tb-button>
    </app-tb-tooltip-component>
    <app-tb-tooltip-component
        [tooltip]="tButtons('edit')"
        [tooltipDisabled]="!displayTooltip"
        *appEnv="'prod'; visible: false"
        class="xsm:w-full sm:w-auto"
    >
        <app-tb-menu [template]="fieldsMenu" #tbFieldsMenu>
            <app-tb-button
                trigger
                [class.bg-primary]="tbFieldsMenu.menuOpen"
                [dark]="dark"
                color="xsm:text sm:white"
                icon="cached"
                appearance="text"
                class="xsm:rounded xsm:bg-neutral2 sm:bg-transparent xsm:w-full xsm:body-1 sm:body-2 xsm:text-text sm:text-whit"
            >
                <span
                    class="xsm:block sm:hidden lg:inline-flex xsm:body-1 sm:body-2 xsm:ms-2 sm:ms-0"
                >
                    {{ tButtons('edit') }}
                </span>
            </app-tb-button>
        </app-tb-menu>
    </app-tb-tooltip-component>
    <app-tb-tooltip-component
        [tooltip]="tButtons('delete')"
        [tooltipDisabled]="!displayTooltip"
        class="xsm:w-full sm:w-auto"
    >
        <app-tb-button
            [dark]="dark"
            icon="custom_trash"
            color="xsm:red-600 "
            appearance="text"
            (click)="deleteAllRecords()"
            class="xsm:rounded xsm:bg-neutral2 sm:bg-transparent xsm:w-full xsm:body-1 sm:body-2 xsm:text-red-600 sm:text-white"
        >
            <span
                class="xsm:block xsm:text-left sm:hidden lg:inline-flex xsm:body-1 sm:body-2 xsm:ms-2 sm:ms-0"
            >
                {{ tButtons('delete') }}
            </span>
        </app-tb-button>
    </app-tb-tooltip-component>
</div>

<ng-template #fieldsMenu>
    @for (field of fieldsList; track field.guid) {
        <app-tb-button
            [appearance]="'text'"
            (click)="editFieldValues(field)"
            class="flex items-center justify-start w-full"
        >
            <span class="w-full flex">
                <app-field-name
                    [field]="field"
                    [showIcon]="true"
                    [workspaceName]="true"
                ></app-field-name>
            </span>
        </app-tb-button>
    }
</ng-template>
